<div
  [ngStyle]="contentStyle"
>
  <div
    [ngStyle]="colorTextAlignStyle"
    [ngClass]="selectedTextStyleClass"
    class="d-contents w-100"
    (click)="onActionClick()"
    [innerHTML]="renderedContent | safeHtml"
  ></div>
</div>
